var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.227 6.6703L9.32972 3.77301M1 15L3.45137 14.7276C3.75087 14.6943 3.90062 14.6777 4.04059 14.6324C4.16477 14.5922 4.28295 14.5354 4.39192 14.4635C4.51474 14.3826 4.62128 14.276 4.83436 14.0629L14.4 4.49734C15.2 3.69727 15.2 2.40011 14.4 1.60005C13.5999 0.799985 12.3027 0.799984 11.5027 1.60005L1.93708 11.1656C1.72399 11.3787 1.61745 11.4853 1.53646 11.6081C1.4646 11.7171 1.4078 11.8352 1.3676 11.9594C1.32229 12.0994 1.30565 12.2491 1.27237 12.5486L1 15Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenImg);
export default __webpack_public_path__ + "static/media/pen-img.67dd98e11cbff2478ed828bed1edd9c6.svg";
export { ForwardRef as ReactComponent };